import { azureAppRegistrationsAnnotation } from './azureAppRegistrationsAnnotation';
import { azureSubscriptionsFromAnnotation } from './azureSubscriptionsAnnotation';

// hasAzureResources(entity.metadata.annotations) -> false when neither annotation yields entries
export function hasAzureResources(annotations: Record<string, string> | undefined): boolean {
  return (
    azureSubscriptionsFromAnnotation(annotations).length > 0 ||
    azureAppRegistrationsAnnotation(annotations).length > 0
  );
}
